import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import Splide from '@splidejs/splide';

interface TeacherVoice {
  message: string;
  thumbnailUrl: string;
  subject: string;
  teacherName: string;
}

interface InterviewArticle {
  id: number;
  title: string;
  schoolName: string;
  name: string;
  description: string;
  thumbnailUrl: string;
  link: string;
  objectPosition?: string; // 画像の重心位置（例: 'top left', 'center center', 'bottom right'）
}

@Component({
  selector: 'app-content-lp-interview-section',
  templateUrl: './content-lp-interview-section.component.html',
  styleUrls: ['./content-lp-interview-section.component.scss']
})
export class ContentLpInterviewSectionComponent implements OnInit, AfterViewInit, OnDestroy {
  teacherVoices: TeacherVoice[] = [
    {
      message: '主に読解問題を生徒の自習用のプリント教材として使っていて、生徒に好評です。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-1.png',
      subject: '英語',
      teacherName: '英語の先生'
    },
    {
      message: '大学名を見て、難しい問題にもチャレンジしようという生徒の意識が高くなりました。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-2.png',
      subject: '数学',
      teacherName: '数学の先生'
    },
    {
      message: '解説が充実している点は、他社商品にはないため大変助かります。操作に慣れてきたら、さらに活用できそうです。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-3.png',
      subject: '生物',
      teacherName: '生物の先生'
    },
    {
      message: '分野別・難度別・年度別・国公私別・地域別に問題を検索できることや、問題と解答を別に印刷できることが便利です。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-4.png',
      subject: '物理',
      teacherName: '物理の先生'
    },
    {
      message: '授業内での演習や、長期休みの講習で使用しています。デジタルで検索できることは、本より便利です。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-5.png',
      subject: '世界史',
      teacherName: '世界史の先生'
    },
    {
      message: '書籍で調べるより格段に速くなり、業務の効率化につながっています。',
      thumbnailUrl: '/assets/images/lp/voice-thumb-6.png',
      subject: '数学',
      teacherName: '数学の先生'
    }
  ];

  // カルーセル用データ
  interviewArticles: InterviewArticle[] = [
    {
      id: 1,
      title: '分野検索とWord編集で過去問教材づくりが大幅に効率化',
      schoolName: '洛南高等学校・洛南高等学校附属中学校',
      name: '栗林幸信 先生',
      description:
        '分野検索で必要な問題をすぐ抽出し、Word編集で教材作成も大幅に効率化。生物を中心に、過去問演習準備の負担を軽減する実践例をご紹介します。',
      thumbnailUrl:
        'https://images.microcms-assets.io/assets/195a5a04fcc14879b2f44b7a9ce2cac4/4807bfbed6aa4a7e9a7d081b0eff7ccf/%E3%80%9020251016%E3%80%91%E3%80%90%E6%B4%9B%E5%8D%97%E9%AB%98%E7%AD%89%E5%AD%A6%E6%A0%A1%E6%A7%98%E3%80%91%E6%97%BA%E6%96%87%E7%A4%BE%E5%85%A5%E8%A9%A6%E6%AD%A3%E8%A7%A3%E3%83%87%E3%82%B8%E3%82%BF%E3%83%AB%EF%BC%BFWEB%E3%82%B5%E3%82%A4%E3%83%88%EF%BC%BF%E6%8E%B2%E8%BC%89%E7%94%BB%E5%83%8F.jpg',
      link: 'https://kakomon.obunsha.co.jp/topic/plxcni-8_xl',
      objectPosition: 'top center'
    },
    {
      id: 2,
      title: '文理問わず好評！おすすめ問題セットや検索機能が便利',
      schoolName: '佐賀県立致遠館高等学校',
      name: '化学・生物・国語  担当の先生方',
      description:
        '国語・理科など複数教科で活用が広がり、条件検索やおすすめ問題セットが教材作りを強力に支援。先生方が実際にどう使っているのか伺いました。',
      thumbnailUrl:
        'https://images.microcms-assets.io/assets/195a5a04fcc14879b2f44b7a9ce2cac4/5e695b2ebc5e4b2da111ba337456369c/IMG_3084.JPG',
      link: 'https://kakomon.obunsha.co.jp/topic/nj4rm6fj48'
    },
    {
      id: 3,
      title: '複数大学の過去問を活用！生徒の実戦力と自信を底上げ',
      schoolName: '桃山学院高等学校',
      name: '和田圭介 先生',
      description:
        '多くの大学の過去問を手軽に活用でき、生徒の実戦力と自信向上に直結。授業・補講での活用方法や、導入後の変化について先生にお聞きしました。',
      thumbnailUrl:
        'https://images.microcms-assets.io/assets/195a5a04fcc14879b2f44b7a9ce2cac4/1ef95f2dd449456ca59778c08f5e48be/SKN_7367.JPG',
      link: 'https://kakomon.obunsha.co.jp/topic/w2n-_q27ldwp'
    }
  ];

  // レスポンシブ制御
  isMobile = false;

  // Splideインスタンス
  private splidePc: Splide | null = null;
  private splideMobile: Splide | null = null;

  // wheelイベントハンドラとDOM要素の参照（メモリリーク対策）
  private wheelHandler: ((e: WheelEvent) => void) | null = null;
  private wheelElement: HTMLElement | null = null;
  private debounceTimer: number | null = null;
  private isScrolling = false;

  constructor() {
    this.checkMobile();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // 初期化を遅延させてDOMの準備を待つ
    setTimeout(() => {
      this.initializeSplide();
      // PC用カルーセルに横方向マウスホイールスクロールを追加
      if (!this.isMobile && this.splidePc) {
        this.addHorizontalWheelSupport(this.splidePc);
      }
    }, 100);
  }

  ngOnDestroy() {
    // wheelイベントリスナーを削除（メモリリーク対策）
    if (this.wheelHandler && this.wheelElement) {
      this.wheelElement.removeEventListener('wheel', this.wheelHandler);
      this.wheelHandler = null;
      this.wheelElement = null;
    }
    // タイマーをクリア
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.isScrolling = false;
    this.destroySplide();
  }

  @HostListener('window:resize')
  onResize() {
    const wasMobile = this.isMobile;
    this.checkMobile();

    // モバイル/PC切り替え時に再初期化
    if (wasMobile !== this.isMobile) {
      // 既存のwheelイベントリスナーを削除
      if (this.wheelHandler && this.wheelElement) {
        this.wheelElement.removeEventListener('wheel', this.wheelHandler);
        this.wheelHandler = null;
        this.wheelElement = null;
      }
      // タイマーをクリア
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      this.isScrolling = false;
      this.destroySplide();
      setTimeout(() => {
        this.initializeSplide();
        // PC用カルーセルに横方向マウスホイールスクロールを追加
        if (!this.isMobile && this.splidePc) {
          this.addHorizontalWheelSupport(this.splidePc);
        }
      }, 100);
    }
  }

  private checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  private initializeSplide() {
    if (!this.isMobile) {
      // PC用: 中央配置、無限ループ、カード幅を852pxに固定
      const pcElement = document.querySelector('.splide-pc');
      if (pcElement) {
        this.splidePc = new Splide('.splide-pc', {
          type: 'loop',
          focus: 'center',
          gap: '36px',
          fixedWidth: '852px', // wrapperのsize="md"の実コンテンツ幅 (900px - 48px padding)
          autoplay: false,
          arrows: true,
          pagination: true,
          width: '100%',
          autoHeight: false, // すべてのスライドの高さを揃える
          breakpoints: {
            900: {
              fixedWidth: 'calc(100vw - 100px)' // 画面幅が900px以下の場合、画面を突き破らないように調整
            }
          }
        });
        this.splidePc.mount();
      }
    } else {
      // スマホ用: 左端配置、見切れ表示
      const mobileElement = document.querySelector('.splide-mobile');
      if (mobileElement) {
        this.splideMobile = new Splide('.splide-mobile', {
          type: 'slide',
          focus: 0,
          gap: '16px',
          fixedWidth: '70vw',
          padding: { left: '1rem', right: '1rem' },
          perPage: 1,
          autoplay: false,
          arrows: false,
          pagination: true,
          trimSpace: true,
          autoHeight: false, // すべてのスライドの高さを揃える
          speed: 300, // アニメーション速度を少し遅く（デフォルト: 400ms）
          flickPower: 200, // スワイプの強度を少し抑える（デフォルト: 600）
          flickMaxPages: 1, // 一度のスワイプで最大1ページまで移動
          waitForTransition: false, // アニメーション完了を待つ
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)' // スムーズなイージング
        });
        this.splideMobile.mount();
      }
    }
  }

  private destroySplide() {
    if (this.splidePc) {
      this.splidePc.destroy();
      this.splidePc = null;
    }
    if (this.splideMobile) {
      this.splideMobile.destroy();
      this.splideMobile = null;
    }
  }

  /**
   * PC用カルーセルに横方向マウスホイールスクロール機能を追加
   * トラックパッドの2本指スワイプやShift+ホイールに対応
   */
  private addHorizontalWheelSupport(splide: Splide) {
    const trackElement = splide.root;
    this.wheelElement = trackElement;
    const SCROLL_THRESHOLD = 30; // スクロール量の閾値（この値以上で反応）
    const DEBOUNCE_TIME = 600; // デバウンス時間（ミリ秒）

    // wheelイベントハンドラを保持（メモリリーク対策）
    this.wheelHandler = (e: WheelEvent) => {
      const absDeltaX = Math.abs(e.deltaX);
      const absDeltaY = Math.abs(e.deltaY);

      // 横方向のスクロールが縦方向より大きく、かつ閾値を超えている場合のみ処理
      if (absDeltaX > absDeltaY && absDeltaX > SCROLL_THRESHOLD) {
        e.preventDefault();

        if (this.isScrolling) return;
        this.isScrolling = true;

        // 横スクロール方向に応じてスライド移動（this.splidePc経由で参照）
        if (this.splidePc) {
          if (e.deltaX > 0) {
            this.splidePc.go('>'); // 右にスクロール → 次へ
          } else {
            this.splidePc.go('<'); // 左にスクロール → 前へ
          }
        }

        // デバウンス: 指定時間後に次のスクロールを受け付ける
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = window.setTimeout(() => {
          this.isScrolling = false;
          this.debounceTimer = null;
        }, DEBOUNCE_TIME);
      }
    };

    trackElement.addEventListener('wheel', this.wheelHandler, { passive: false });
  }
}
